<script lang="ts">import { blurOnClick } from '../../../../js-v2/blurOnClick';
const { id = '', title = '', url = '#', linkStyle = 'primary', linkCustomCssClass = undefined, svgIcon = undefined, openInNewTab = false, } = $props();
</script>

<a
  href={url}
  class="Link--button {linkStyle} {linkCustomCssClass || ''}"
  data-entry-id={id}
  target={openInNewTab ? '_blank' : undefined}
  use:blurOnClick
>
  {#if svgIcon}
    <span class="icon">
      <!-- eslint-disable-next-line svelte/no-at-html-tags - icon is imported from public-web-icons -->
      {@html svgIcon}
    </span>
  {/if}
  <span class="title">{title}</span>
</a>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Link--button {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px;
  border-radius: 10000px;
  padding: 16px 20px;
}
.Link--button:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--button:focus {
  background: transparent;
  outline: none;
}
.Link--button:hover {
  background: transparent;
}
.Link--button:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: 10000px;
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--button.primary, .Link--button.primary::before {
  background-color: var(--color-text, var(--color-neutral-000, #000000));
}
.Link--button, .Link--button:hover {
  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1);
}
.Link--button::before, .Link--button::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transform: scale(1);
  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1);
}
.Link--button::before {
  border: 1px solid var(--color-text, var(--color-neutral-000, #000000));
  border-radius: 10000px;
}
.Link--button::after {
  pointer-events: none;
  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1);
  border-radius: 10000px;
  z-index: calc(var(--current-z-index, 1) + 1);
  mix-blend-mode: screen;
  opacity: 0;
}
.Link--button:hover::before, .Link--button:hover::after {
  transform: scale(1.05);
}
.Link--button:active {
  transform: translateY(5%);
}

.icon {
  display: inline-flex;
  align-items: center;
}
.icon :global(svg *) {
  fill: var(--color-text, var(--color-neutral-000, #000000));
}

.title {
  --letter-spacing: var(--text-variant-50-letter-spacing);
  --line-height: var(--text-variant-50-line-height);
  --font-size: var(--text-variant-50-font-size);
  --font-weight: var(--text-variant-50-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-50-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  position: relative;
}
.primary .title {
  color: var(--color-background, var(--color-neutral-000, #000000));
}</style>
